/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import { Box } from "@material-ui/core";
import { useI18n } from "hooks/i18n/i18n";
import React from "react";

import { AddToCartButton } from "./AddToCartButton";
import { ProductImageWithInfo } from "./ProductImageWithInfo";
import { SelectVariationSelectBox } from "./SelectVariationSelectBox";

import type { ProductData } from "@spwn/types/firebase/firestore";
import type { FC } from "react";

export const LiveCommerceListItem: FC<{
  isDarkModeEnabled: boolean;
  item: ProductData;
  goodsVariationList: ProductData[];
  openGoodsInfo: (goodsItem: ProductData) => void;
  addToCart: (classGoodsList: ProductData[]) => void;
  selectVariation: (productId: string) => void;
}> = ({
  isDarkModeEnabled,
  item,
  goodsVariationList,
  openGoodsInfo,
  addToCart,
  selectVariation,
}) => {
  const { t } = useI18n();

  return (
    <Box display={"flex"} gridGap={"8px"}>
      <Box>
        <ProductImageWithInfo
          goodsItem={item}
          onClick={() => openGoodsInfo(item)}
        />
      </Box>

      <Box display={"flex"} flexDirection={"column"}>
        <Box flex={"1 1 auto"} marginBottom={"8px"}>
          <Box
            marginBottom={"8px"}
            color={isDarkModeEnabled ? "#fff" : "#000"}
            fontSize={"14px"}
            lineHeight={"1.5em"}
            css={css`
              word-break: break-all;
            `}
          >
            {item.name}
          </Box>

          <Box
            component={"p"}
            color={isDarkModeEnabled ? "#fff" : "#000"}
            fontSize={"14px"}
          >
            ¥{item.price_jpy.toLocaleString()}
            <Box component={"span"} marginLeft={"4px"} fontSize={"12px"}>
              {t("streaming.commerceGoodsList.tax")}
            </Box>
          </Box>
        </Box>

        {goodsVariationList.length === 1 ? null : (
          <Box marginBottom={"8px"}>
            <SelectVariationSelectBox
              variationList={goodsVariationList}
              onChange={selectVariation}
            />
          </Box>
        )}

        <AddToCartButton
          isDarkModeEnabled={isDarkModeEnabled}
          onClick={() => {
            addToCart(goodsVariationList);
          }}
        />
      </Box>
    </Box>
  );
};
